export default __webpack_public_path__ + "static/media/eye_open.610e3e59.svg";